import { ShipmentCreationTemplate } from '@features/shipments/models/shipment-template.model';
import { ShipmentCreationTemplateTypes } from '@shared-features/enums/shipments.enum';

/**
 * Collapse creation templates to one per type, preferring the default template of each type.
 * Shared by the Add-shipment button and the sidenav so both resolve the same template per type
 * for the same user.
 */
export function dedupeTemplatesByType(templates: ShipmentCreationTemplate[]): ShipmentCreationTemplate[] {
  const byType = new Map<ShipmentCreationTemplateTypes, ShipmentCreationTemplate>();
  for (const template of templates || []) {
    if (!byType.has(template.type) || template.isDefault) {
      byType.set(template.type, template);
    }
  }
  return [...byType.values()];
}
